<template>
  <vg-view-field
      v-bind="$attrs"
      v-on="$listeners"
      :label="label"
      :value="value.projectName"
  />
</template>

<script>
import VgViewField from "@/components/Commons/VgViewField.vue";

export default {
  name: "ProjectField",
  components: {VgViewField},
  props: {
    label: String,
    value: Object,
  }
}
</script>

<style scoped>

</style>